//@ts-nocheck
/**
 * title提示
 */
var globalTimeoutHover_title, globalTimeoutHoverOut_title;
var initHtml = ['<div class="pop">',
    '<i class="arrow arrowTop"></i>',
    '<div class="popContent">',
    '</div>',
    '</div>'
].join("");
if ($(".pop").length <= 0)
    $("body").prepend(initHtml);
var $pop = $(".pop");
var wwidth = $(window).width();
var wheight = $(window).height();
var popheight = $pop.height();
var popwidth = $pop.width();
$(document).on("mouseover", ".popCla", function (event) {
    if (!!globalTimeoutHoverOut_title) {
        clearTimeout(globalTimeoutHoverOut_title);
    }
    var _this = $(this);
    var title = _this.data('title');
    var showhtml = _this.data('showhtml');
    var height = _this.height();
    var left = _this.offset().left;
    var top = _this.offset().top + height;
    var wstop = $("html").scrollTop() || $("body").scrollTop();
    globalTimeoutHover_title = setTimeout(function () {
        if (wheight + height - (top - wstop) < popheight) {
            top = top - height - popheight - 33;
            $(".arrow", $pop).removeClass('arrowTop').addClass('arrowBottom');
        }
        else {
            $(".arrow", $pop).removeClass('arrowBottom').addClass('arrowTop');
        }
        if (showhtml)
            $('.popContent', $pop).html(title);
        else
            $('.popContent', $pop).text(title);
        $pop.show();
        $pop.css({ left: left, top: top });
    }, 200);
});
$(document).on("mouseout", ".popCla", function (event) {
    if (!!globalTimeoutHover_title) {
        clearTimeout(globalTimeoutHover_title);
    }
    globalTimeoutHoverOut_title = setTimeout(function () {
        $pop.hide();
    }, 200);
});
$(document).on("mouseenter", ".pop", function (event) {
    if (!!globalTimeoutHoverOut_title) {
        clearTimeout(globalTimeoutHoverOut_title);
    }
});
$(document).on("mouseleave", ".pop", function (event) {
    $pop.hide();
});
